import React, { ErrorInfo } from 'react';

export interface ErrorBoundaryProps {
    /**
     * Elements of the page to display when there are no rendering errors
     */
    fallbackRender: () => React.ReactNode;
    children: React.ReactNode;
    disabled?: boolean;
    onErrorCatch: (error: Error, errorInfo: ErrorInfo) => void;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (this.props.onErrorCatch) {
            this.props.onErrorCatch(error, errorInfo);
        }
    }

    render() {
        const { children, disabled = false, fallbackRender } = this.props;

        return this.state.hasError && !disabled ? fallbackRender() : children;
    }
}
